import { Asset } from "@hydrologiq/gql-experience/graphql"
import CurrentOrderStatus from "../generic/CurrentOrderStatus"

interface AssetCurrentOrderProps {
  context?: Asset
}

const AssetCurrentOrder = ({ context }: AssetCurrentOrderProps) => {
  // Convert single current_order to array for the generic component
  const orders = context?.current_order ? [context.current_order] : []

  return <CurrentOrderStatus orders={orders} assetId={context?.id} loading={!context} />
}

export default AssetCurrentOrder
